<div class="split-container">
  <div class="side-menu">
    <app-side-menu></app-side-menu>
  </div>
  <div class="content">
    <router-outlet></router-outlet>
  </div>
</div>